import { useQueryClient } from 'react-query';
import { QUERY_KEYS } from '../constants/queryKeys';
import type { ImageSearchResponseType } from '../types/type';

export const useImageSearchResultItemActions = () => {
  const queryClient = useQueryClient();

  /**
   * 선택된 카드를 candidates 배열의 맨 앞으로 이동
   * 1. position이 인자와 일치하는 results 의 요소(result) 찾기
   * 2. 선택된 카드와 나머지 카드 분리
   * 3. 선택된 카드를 candidates 배열의 맨 앞으로 이동
   * 4. 선택된 카드가 없으면 원래 result 반환
   */
  const selectResultCandidate = ({
    position,
    photoCardId
  }: {
    position: number;
    photoCardId: string;
  }) => {
    queryClient.setQueryData<ImageSearchResponseType | undefined>(
      QUERY_KEYS.IMAGE_SEARCH_RESULT,
      (old: ImageSearchResponseType | undefined) => {
        if (!old) return old;
        return {
          ...old,
          results: old.results.map((result) => {
            // 1. position이 인자와 일치하는 results 의 요소(result) 찾기
            if (result.position !== position) {
              return result;
            }

            // 2. 선택된 카드와 나머지 카드 분리
            let selectedCandidate = null;
            const filteredCandidates = [];
            for (const candidate of result.candidates) {
              if (candidate.photoCardId === photoCardId) {
                selectedCandidate = candidate;
              } else {
                filteredCandidates.push(candidate);
              }
            }

            // 3. selectedCandidate가 없으면 원래 result 반환
            if (!selectedCandidate) {
              return result;
            }

            // 4. 선택된 카드를 candidates 배열의 맨 앞으로 이동
            return {
              ...result,
              candidates: [selectedCandidate, ...filteredCandidates]
            };
          })
        };
      }
    );
  };

  //포지션이랑 일치하는 results의 요소 삭제
  const deleteResultItem = (position: number) => {
    queryClient.setQueryData<ImageSearchResponseType | undefined>(
      QUERY_KEYS.IMAGE_SEARCH_RESULT,
      (old: ImageSearchResponseType | undefined) => {
        if (!old) return undefined;
        return {
          ...old,
          results: old.results.filter((result) => result.position !== position)
        };
      }
    );
  };

  return {
    selectResultCandidate,
    deleteResultItem
  };
};
